<template lang="pug">
.cp-contact-us
  .w
    .title 联系我们
    .sub-title1 竭诚恭候莅临指导，期待合作
    .content
      .left
        .left-top
          p 商务合作
          p.fontA info@cell.work
      .right
        .msg
          p.name 万蚓网络科技(上海)有限公司
          p.ess 上海市杨浦区黄兴路2218号合生国际中心1104
        img.ps(src="../../../assets/location2.png")
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
.cp-contact-us
  padding-top 56px
  padding-bottom 41px
  .w
    padding 0 45px
  .title
    font-size 24px
  .sub-title1
    margin-top 12px
    margin-bottom 21px
    font-size 18px
    color rgba(158,234,250,1)
    text-align center
  .content
    display flex
    justify-content space-between
    align-items center
    .left
      width 528px
      .left-top
        padding-bottom 29px
        //border-bottom 1px solid rgba(255,255,255,0.3)
        p
          &:first-child
            font-weight 500
            margin-bottom 10px
          &:last-child
            color #9eeafa
            font-size 24px
      .left-bottom
        padding-top 28px
        display flex
        .item
          p
            color rgba(158,234,250,1)
            &:first-child
              color #fff
            &:nth-child(2)
              margin 10px 0px
          &:nth-child(2)
            margin 0px 40px
    .right
      position relative
      width 508px
      height 336px
      background url('../../../assets/map.svg') center / 100% 100%
      .msg
        margin 50px 0 0 220px
        width 278px
        height 110px
        background url('../../../assets/msg-bg.png')
        background-size 100% 100%
        padding 20px 30px 0 30px
        font-size 16px
        position relative
        &::after
          content ''
          position absolute
          top 50px
          left 30px
          z-index 1
          width 140px
          height 1px
          background #176581
        .address
          font-size 12px
          color rgba(89,181,200,1)
          padding-top 17px
      .ps
        position absolute
        top 170px
        left 170px
        width 50px
        height 55px
        animation mybounce 1s infinite
@keyframes mybounce {
  0%, 20%, 53%, 80%, 100% {
    animation-timing-function cubic-bezier(0.215, 0.61, 0.355, 1)
    transform translate3d(0, 0, 0)
  }
  40%, 43% {
    animation-timing-function cubic-bezier(0.755, 0.05, 0.855, 0.06)
    transform translate3d(0, -15px, 0)
  }
  70% {
    animation-timing-function cubic-bezier(0.755, 0.05, 0.855, 0.06)
    transform translate3d(0, -7px, 0)
  }
  90% {
    transform translate3d(0, -3px, 0)
  }
}
</style>
